
import React, { Component } from 'react';
import { Button } from '@massds/mayflower-react';
import {
  ComposableMap, ZoomableGroup, Geographies, Geography
} from 'react-simple-maps';
import { scaleQuantile } from 'd3-scale';
import { schemeBuPu } from 'd3-scale-chromatic';
import axios from 'axios';
import csv from 'csvtojson';
import ReactTooltip from 'react-tooltip';
import { quantile, ascending } from 'd3-array';
import LegendQuantile from '../Legend/Quantile';
import { customFormat0 } from '../helper';
import './Map.css';

import masstowns from '../data/masstowns.topo.json';

const colorScaleQuant = scaleQuantile();
const colorBostonScale = scaleQuantile()
  .domain([0, 7586, 15340, 34522, 90416, 273416, 35221873])
  .range(schemeBuPu[7]);

class DestinationTripsMap extends Component {
  constructor() {
    super();
    this.state = {
      allData: [],
      center: [-71.63627925574303, 42.13276308419552],
      zoom: 1,
      disablePan: true,
      colorScale: colorScaleQuant,
      areas: [
        {
          name: 'Greater Boston', coordinates: [-71.03627925574303, 42.33276308419552], zoom: 4, colorScale: colorBostonScale
        },
        {
          name: 'Cape Cod', coordinates: [-70.388761, 41.681497], zoom: 2.15, colorScale: colorScaleQuant
        },
        {
          name: 'North Shore', coordinates: [-70.982613, 42.655939], zoom: 4, colorScale: colorScaleQuant
        },
        {
          name: 'Central Mass', coordinates: [-72.217152, 42.419665], zoom: 2.5, colorScale: colorScaleQuant
        },
        {
          name: 'Western Mass', coordinates: [-73.014503, 42.399396], zoom: 3, colorScale: colorScaleQuant
        }
      ]
    };
    this.handleAreaSelection = this.handleAreaSelection.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  parseData = (data) => {
    const allData = [];
    csv({
      noheader: false
    }).fromString(data)
      .subscribe((json) => {
        allData.push(json);
      })
      .on('done', () => {
        this.setState({ allData });
      })
      .on('error', (err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }

  fetchData = () => {
    const _this = this;
    axios.all([axios.get('../data/Rideshare_stats_v4.csv')])
      .then(axios.spread((result) => {
        const { data } = result;
        _this.parseData(data);
      }))
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  };

  handleAreaSelection(e, i) {
    const { areas } = this.state;
    const area = areas[i];
    this.setState({
      center: area.coordinates,
      zoom: area.zoom,
      colorScale: area.colorScale,
      name: area.name,
      disablePan: false
    });
  }

  handleReset() {
    this.setState({
      center: [-71.63627925574303, 42.13276308419552],
      zoom: 1,
      colorScale: colorScaleQuant,
      disablePan: true,
      name: 'Massachusetts'
    });
  }

  render() {
    const {
      allData, colorScale, center, zoom, disablePan, areas, name
    } = this.state;
    if (allData.length === 0) {
      return<div className="container">Loading...</div>;
    }
    const destArray = allData.map((item) => Number(item.DESTINATION_TRIPS));
    destArray.sort(ascending);

    const breaks = [0, parseInt(quantile(destArray, 0.125), 10), parseInt(quantile(destArray, 0.25), 10), parseInt(quantile(destArray, 0.375), 10), parseInt(quantile(destArray, 0.5), 10), parseInt(quantile(destArray, 0.625), 10), parseInt(quantile(destArray, 0.75), 10), parseInt(quantile(destArray, 0.875), 10), parseInt(quantile(destArray, 1.00), 10)];

    if (name !== 'Greater Boston') {
      colorScale.domain(breaks).range(schemeBuPu[9]);
    }

    return(
      <div>
        <div className="wrapperButtonStyles">
          {
            areas.map((area, i) => (
              <Button
                size="small"
                info="Zoom to area on map."
                text={area.name}
                onClick={(e) => this.handleAreaSelection(e, i)}
                usage="secondary"
                // eslint-disable-next-line react/no-array-index-key
                key={`destinationMap_button-${i}`}
              />
            ))
          }
          <Button
            size="small"
            info="Zoom out to full state."
            text="Reset"
            onClick={this.handleReset}
            usage="secondary"
            // eslint-disable-next-line react/no-array-index-key
            key="destinationMap_button_reset"
            theme="c-primary-alt"
          />
        </div>
        <div className="wrapperStyles">
          <div className="wrapperMapStyles">
            <ComposableMap
              projection="mercator"
              projectionConfig={{
                scale: 12000
              }}
              width={980}
              height={530}
              style={{
                width: '100%',
                height: 'auto'
              }}
            >
              <ZoomableGroup center={center} zoom={zoom} disablePanning={disablePan}>
                <Geographies geography={masstowns} disableOptimization>
                  {(geographies, projection) => geographies.map((geography, i) => {
                    const townData = allData.find((s) => s.FIPS_CODE === geography.id) || {};
                    const town = townData.TOWN;
                    const metric = townData.DESTINATION_TRIPS;
                    const fill = colorScale(metric);
                    return(
                      <Geography
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${i}three`}
                        cacheId={`${i}three`}
                        round
                        geography={geography}
                        projection={projection}
                        data-html
                        data-tip={`<strong>${town}</strong><br><strong>Destination Trips</strong>: ${customFormat0(metric)}`}
                        style={{
                          default: {
                            fill,
                            stroke: '#dcdcdc',
                            strokeWidth: 0.5,
                            outline: 'none'
                          },
                          hover: {
                            fill,
                            stroke: 'rgba(255,255,255,1.0)',
                            fillOpacity: '0.7',
                            strokeWidth: 2.00,
                            outline: 'true'
                          },
                          pressed: {
                            fill,
                            stroke: 'rgba(255,255,255,1.0)',
                            fillOpacity: '0.3',
                            strokeWidth: 2.00,
                            outline: 'true'
                          }
                        }}
                      />
                    );
                  })}
                </Geographies>
              </ZoomableGroup>
            </ComposableMap>
            <ReactTooltip type="light" />
          </div>
          <div className="wrapperLegendStyles">
            <p className="legendTitle">Total Destination Trips</p>
            <LegendQuantile
              scale={colorScale}
              direction="column"
              labelMargin="0 5px 0 0"
              shape="rect"
              labelFormat={customFormat0}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DestinationTripsMap;
